import { ideaConverter } from "./converter";

export const createIdeaApi = (values) => (dispatch, getState, { api }) => {
  return api.post("/private/idea/create", ideaConverter.forBE(values));
};
